import { createContext, Context, Accessor, Setter } from 'solid-js'
import { Navigator } from '@solidjs/router';
import { MatchStatus } from '../utils'
import { PlayerOverlays, RemoteKeyPressed } from '../constants';
import { IRequestPlaybackParama } from './PlayerProvider.interface';

declare global {
    interface Window {
        voltPlayer: any
    }
}

export interface PlayerProviderBehavior {
    program: Accessor<any>,
    channel: Accessor<any>,
    programId: () => string,
    channelId: () => string,
    voltApi: () => any,
    player: Accessor<any>,
    setPlayer: Setter<any>,
    multicamData: () => any,
    loading: Accessor<boolean>,
    setLoading: Setter<boolean>
    gameId: Accessor<string>
    matchStatus: Accessor<MatchStatus | undefined>,
    canBookmark: () => boolean
    userPcRestrictions: Accessor<any>,
    isTrailer: Accessor<boolean>
    playerPublish: any,
    loadedMetaData: Accessor<boolean>,
    setLoadedMetaData: Setter<boolean>
    isLiveProgram: Accessor<boolean>
    navigate: Navigator,
    overlay: Accessor<PlayerOverlays | undefined>
    setOverlay: Setter<PlayerOverlays | undefined>
    showParental: Accessor<boolean>,
    setShowParental: Setter<boolean>,
    keyPressed: Accessor<RemoteKeyPressed | undefined>
    setKeyPressed: Setter<RemoteKeyPressed | undefined>
    isStartOverAllowed: Accessor<boolean>
    pausedByUser: Accessor<boolean>
    setPausedByUser: Setter<boolean>
    getDrmConfig: Accessor<unknown>
    requestPlaybackUrl: (params: IRequestPlaybackParama) => void
    criticalError: Accessor<any>
    setCriticalError: Setter<{
        header: String;
        message: string;
    } | undefined>
    errorHandler: (severity: number, errorCode: number, message: string, ssmType?: string) => void
    gfkS2sFonction: (w: any, d: any, c: any, s: any, id: any) => void,
    gfk: Accessor<any>,
    setGfk: Setter<any>,
    streamId: Accessor<string>
    isFullscreen: Accessor<boolean>
    setIsFullscreen: Setter<boolean>
    adData: Accessor<any>
    setAdData: Setter<any>
    isTileDetail: Accessor<boolean>
    setIsTileDetail:Setter<boolean>
    showUnsuscribedPopUp: Accessor<boolean>
    purchasePopUpOpen: Accessor<boolean>
}

export const PlayerProviderContext: Context<PlayerProviderBehavior | undefined> = createContext(undefined)
